<template>
  <BaseModal
    name="сonsumptionBalanceSecondStepModal"
    width="890"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    @before-open="loadData"
    :adaptive="true"
    height="795"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('сonsumptionBalanceSecondStepModal')"
      ></button>
      <div class="tw-text-center">
        <div class="tw-app-modal__title">{{ dataLang["reg_company_30"] }}</div>

        <div class="tw-app-modal__title tw-text-forText">
          {{ dataLang["reg_company_29"] }}
        </div>

        <div
          class="overflow-auto wp-100"
          style="min-height: 550px; max-height: 551px"
        >
          <ve-table
            class="rest-style-table"
            style="width: 100%"
            :columns="columns"
            :table-data="dataTable"
            :border-x="true"
            :border-y="true"
            row-key-field-name="companies__id"
            ref="mainTable"
            :eventCustomOption="eventCustomOption"
            v-if="!localLoading"
            :cell-style-option="cellStyleOption"
            :checkbox-option="{
              selectedRowChange: selectedRowChange,
              selectedAllChange: selectedAllChange,
              hideSelectAll: false,
            }"
            :clickHighlight="false"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          >
          </ve-table>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('сonsumptionBalanceSecondStepModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["reg_company_23"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_company_24"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      link: "",
      localLoading: false,
      activeSelectRowsMultiple: [],
      dataForEmit: {},
      pincode: "",
      currentId: null,
      fileUrl: "",
      computedTransData: "",
      dataTable: [],
      counterString: "",
      minBalance: "",
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {};
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    beforeClose() {
      this.computedTransData = "";
      this.dataTable = [];
      this.counterString = "";
      this.activeSelectRowsMultiple = [];
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
      // this.calculateTranslate()
    },
    loadData({ params }) {
      this.pincode = params?.pincode;
      this.localLoading = true;
      this.dataTable = params?.dataTable;
      this.minBalance = params?.minBalance;
      this.localLoading = false;
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values?.[keyName]
        );
      });
      return tranaslateLocal;
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    sendData() {
      console.log(123123123213213, this.activeSelectRowsMultiple);
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("сonsumptionBalanceTreeStepModal", {
          data: {
            minBalance: this.minBalance,
            companyIds: this.activeSelectRowsMultiple,
            pincode: this.pincode,
            dataTable: this.dataTable,
          },
        });
        this.$modal.hide("сonsumptionBalanceSecondStepModal");
      }
    },
  },
  mounted() {
    // this.counterString = this.computedTranslate(
    //   {
    //     number: 0,
    //     total: 0
    //   },
    //   this.dataLang['reg_company_51']
    // )
  },
  created() {
    GeneralService.get(
      `/settings?fields=company_settings__set_security_pass_for_forbidden`
    )
      .then((data) => {
        this.pincode =
          data.data.data.rows[0].company_settings__set_security_pass_for_forbidden;
      })
      .catch((e) => {});
  },
  beforeDestroy() {},
  updated() {
    // console.log(1231233)
    // this.calculateTranslate()
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          field: "companies__id",
          key: "16233226",
          title: this.dataLang["reg_company_1"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__balance_before",
          key: "1623326",
          title: this.dataLang["reg_company_32"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__balance_before
                  ? String(row.companies__balance_before).split(".").join(",")
                  : ""}
              </span>
            );
          },
        },
        {
          field: "company_settings__set_req_company_name",
          key: "163336",
          title: this.dataLang["reg_company_33"],
          align: "center",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_settings__set_req_bik",
          key: "1364326",
          title: this.dataLang["reg_company_34"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_settings__set_req_rs",
          key: "162136",
          title: this.dataLang["reg_company_35"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__balance_out",
          key: "1722551",
          title: this.dataLang["reg_company_36"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__balance_out
                  ? String(row.companies__balance_out).split(".").join(",")
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__balance_rest",
          key: "172551",
          title: this.dataLang["reg_company_37"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__balance_rest
                  ? String(row.companies__balance_rest).split(".").join(",")
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
